import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router";

const OperationsRoutes = () => {
  const { roles } = useSelector(s => s.user);
  const isOperations = roles.includes("Operations");
  console.log(isOperations);

  return isOperations ? <Outlet /> : <Navigate to="/" />;
};

export default OperationsRoutes;